// extracted by mini-css-extract-plugin
export var label = "_ed-0";
export var treatmentCard = "_ed-1";